import { render, staticRenderFns } from "./AnnotationOverlay.vue?vue&type=template&id=678b3a55&scoped=true&"
import script from "./AnnotationOverlay.vue?vue&type=script&lang=js&"
export * from "./AnnotationOverlay.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationOverlay.vue?vue&type=style&index=0&id=678b3a55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678b3a55",
  null
  
)

export default component.exports